import React, { useEffect, useState } from 'react';
import { MaterialTextField } from '@/shared/components/form/MaterialFormElements';
import InputAdornment from '@mui/material/InputAdornment';
import { colorText } from '@/utils/palette';
import styled from 'styled-components';

const PostfixTextField = ({
  name,
  label,
  placeholder,
  variant,
  error,
  postfix,
  includePostfixInValue,
  onChange,
  defaultValue,
  type,
  helperText,
}) => {
  const [inputValue, setInputValue] = useState(defaultValue || '');

  useEffect(() => {
    if (includePostfixInValue && defaultValue) {
      defaultValue = defaultValue + postfix;
    }
    onChange(defaultValue);
  }, []);

  const handleChange = (e) => {
    let newValue = e.target.value;

    if (includePostfixInValue && newValue) {
      newValue = newValue + postfix;
    }

    setInputValue(e.target.value);
    onChange && onChange(newValue);
  };

  const displayValue = includePostfixInValue ? inputValue : inputValue.replace(postfix, '');

  return (
    <MaterialFieldContainer>
      <MaterialTextField
        name={name}
        type={type || 'string'}
        variant={variant || 'standard'}
        label={label}
        placeholder={placeholder || 'Enter the text here...'}
        value={displayValue}
        onChange={handleChange}
        error={error}
        helperText={error}
        InputProps={{
          endAdornment: postfix && (
            <InputAdornment
              position='end'
              style={{ color: colorText }}
            >
              <span>{postfix}</span>
            </InputAdornment>
          ),
        }}
      />
      {helperText && <HelperText>{helperText}</HelperText>}
    </MaterialFieldContainer>
  );
};

export default PostfixTextField;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

export const MaterialFieldContainer = styled.div`
  label {
    font-size: 12px;
    color: ${colorText};

    &[data-shrink='true'] {
      transform: translate(0, 1.5px) scale(0.85);
    }
  }

  h3 {
    margin-top: 40px;
  }

  span {
    color: ${colorText};
  }
  display: flex;
`;
